/**
 * Busca token do Cognito via react-oidc-context
 * Busca apenas do sessionStorage onde o OIDC armazena os dados
 */
export const getToken = () => {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }
    // Busca token do Cognito (react-oidc-context armazena em sessionStorage)
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    if (!cognitoDomain || !clientId) {
        console.warn('Variáveis de ambiente COGNITO_DOMAIN ou CLIENT_ID não configuradas');
        return null;
    }
    const oidcStorageKey = `oidc.user:${cognitoDomain}:${clientId}`;
    const oidcRaw = sessionStorage.getItem(oidcStorageKey);
    if (!oidcRaw) {
        return null;
    }
    try {
        const oidcData = JSON.parse(oidcRaw);
        // Retorna access_token (preferencial para APIs)
        return oidcData.access_token || null;
    }
    catch (error) {
        console.error('Erro ao processar dados OIDC:', error);
        return null;
    }
};
const getDay = (date) => {
    if (!date)
        return '';
    return `${new Date(date).getDate()}`;
};
const getValue = (price) => {
    const numeric = typeof price === 'number' ? price : Number(price);
    if (Number.isNaN(numeric))
        return 0;
    return Number(numeric.toFixed(2));
};
const getNameAndValueArr = (history = []) => history.map(day => ({
    name: getDay(day?.date),
    value: getValue(day.priceUsd),
}));
export const getWeekChartData = (cryptoHistory) => {
    if (!cryptoHistory)
        return null;
    const weekChartDataArr = cryptoHistory.map(item => ({
        currency: item?.currency ?? '',
        history: getNameAndValueArr(item?.history?.slice(7)),
    }));
    return Object.fromEntries(weekChartDataArr.map(item => [item.currency, item.history]));
};
export const getShortCryptoAddress = (value) => `${value.slice(0, 5)}...${value.slice(-3)}`;
